export default __webpack_public_path__ + "static/media/search-funds.9158009c.svg";